import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { API_ENDPOINTS } from '../../config/constants';
import { STRAPI_URL } from '../../config/constants';
// import { useStrapiConstants } from '../../hooks/useStrapiConstants';
import { useStrapiConstants } from '../../contexts/StrapiConstantsContext';
import Loading from '../../components/common/Loading';
const Contact = () => {
    const { loaded, contactPage } = useStrapiConstants();
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        name: '',
        surname: '',
        title: '',
        message: '',
        email: '',
    });

    const [errors, setErrors] = useState({});
    const [touched, setTouched] = useState({});
    const [loading, setLoading] = useState(false);
    if (!loaded) return <Loading />;
    // Validation rules
    const validateField = (name, value) => {
        switch (name) {
            case 'name':
                if (!value.trim()) {
                    return 'Ad alanı zorunludur';
                }
                if (value.trim().length < 2) {
                    return 'Ad en az 2 karakter olmalıdır';
                }
                if (value.trim().length > 50) {
                    return 'Ad en fazla 50 karakter olabilir';
                }
                if (!/^[a-zA-ZğüşöçİĞÜŞÖÇ\s]+$/.test(value)) {
                    return 'Ad sadece harf içermelidir';
                }
                return '';

            case 'email':
                if (!value.trim()) {
                    return 'E-posta alanı zorunludur';
                }
                const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                if (!emailRegex.test(value)) {
                    return 'Geçerli bir e-posta adresi giriniz';
                }
                if (value.length > 100) {
                    return 'E-posta en fazla 100 karakter olabilir';
                }
                return '';

            case 'title':
                if (!value.trim()) {
                    return 'Konu alanı zorunludur';
                }
                if (value.trim().length < 3) {
                    return 'Konu en az 3 karakter olmalıdır';
                }
                if (value.trim().length > 100) {
                    return 'Konu en fazla 100 karakter olabilir';
                }
                return '';

            case 'message':
                if (!value.trim()) {
                    return 'Mesaj alanı zorunludur';
                }
                if (value.trim().length < 10) {
                    return 'Mesaj en az 10 karakter olmalıdır';
                }
                if (value.trim().length > 1000) {
                    return 'Mesaj en fazla 1000 karakter olabilir';
                }
                return '';

            default:
                return '';
        }
    };

    const validateForm = () => {
        const newErrors = {};
        Object.keys(formData).forEach((key) => {
            if (key !== 'surname') { // surname is optional
                const error = validateField(key, formData[key]);
                if (error) {
                    newErrors[key] = error;
                }
            }
        });
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleChange = (e) => {
        const { name, value } = e.target;

        setFormData({
            ...formData,
            [name]: value,
        });

        // Validate field on change if it has been touched
        if (touched[name]) {
            const error = validateField(name, value);
            setErrors({
                ...errors,
                [name]: error,
            });
        }
    };

    const handleBlur = (e) => {
        const { name, value } = e.target;

        setTouched({
            ...touched,
            [name]: true,
        });

        // Validate field on blur
        const error = validateField(name, value);
        setErrors({
            ...errors,
            [name]: error,
        });
    };

    const FullEndPoint = STRAPI_URL + '/api/' + API_ENDPOINTS.CONTACTS;

    const handleSubmit = async (e) => {
        e.preventDefault();

        // Mark all fields as touched
        const allTouched = {};
        Object.keys(formData).forEach(key => {
            allTouched[key] = true;
        });
        setTouched(allTouched);

        // Validate entire form
        if (!validateForm()) {
            alert('Lütfen tüm alanları doğru şekilde doldurunuz');
            return;
        }

        setLoading(true);

        try {
            const response = await fetch(FullEndPoint, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    data: {
                        name: formData.name.trim(),
                        title: formData.title.trim(),
                        message: formData.message.trim(),
                        email: formData.email.trim().toLowerCase(),
                    },
                }),
            });

            const result = await response.json();

            if (!response.ok) {
                throw new Error(result.error?.message || "Bir hata oluştu.");
            }

            alert("Mesajınız başarıyla gönderildi!");

            // Reset form
            setFormData({
                name: '',
                surname: '',
                title: '',
                message: '',
                email: '',
            });
            setErrors({});
            setTouched({});

            navigate(`/`);
        } catch (err) {
            alert("Gönderim başarısız: " + err.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="max-w-7xl mx-auto px-5 py-12">
            <h1 className="text-4xl text-[#1e5a96] mb-8 border-b-4 border-[#1e5a96] pb-4">
                Bize Ulaşın
            </h1>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                {/* Info Section */}
                <div className="bg-white p-8 rounded-lg shadow-md">
                    <h2 className="text-2xl text-[#1e5a96] mb-6">
                        İletişim Bilgileri
                    </h2>

                    <div className="mb-6">
                        <h3 className="text-lg text-gray-800 mb-2">📍 Adres</h3>
                        <p className="text-base text-gray-600 leading-relaxed">
                            <a
                                href={contactPage.addressURL}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                {contactPage.address}
                            </a>
                        </p>
                    </div>

                    <div className="mb-6">
                        <h3 className="text-lg text-gray-800 mb-2">📞 Telefon</h3>
                        <p className="text-base text-gray-600">
                            <a href={`tel:${contactPage.number}`} >
                                {contactPage.number}
                            </a>
                        </p>
                    </div>

                    <div className="mb-6">
                        <h3 className="text-lg text-gray-800 mb-2">📧 E-posta</h3>
                        <p className="text-base text-gray-600">
                            <a href={`mailto:${contactPage.email}`} >
                                {contactPage.email}
                            </a>
                        </p>
                    </div>

                    <div className="mb-6">
                        <h3 className="text-lg text-gray-800 mb-2">🗺️ Konum</h3>
                        <p className="text-base text-gray-600 leading-relaxed">
                            {/* <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d12040.802589338984!2d28.964595!3d41.020866!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14cab9db9dba865f%3A0x81d25e6e9a9df2ba!2sEkonomik%20Ve%20Sosyal%20Ara%C5%9Ft%C4%B1rmalar%20Merkezi!5e0!3m2!1str!2str!4v1763836740314!5m2!1str!2str" width="100%"
                                height="250" allowFullScreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe> */}
                            <iframe src={contactPage.locationEmbed} width="100%"
                                height="250" allowFullScreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>
                        </p>
                    </div>
                </div>

                {/* Form Section */}
                <div className="bg-white p-8 rounded-lg shadow-md">
                    <h2 className="text-2xl text-[#1e5a96] mb-6">
                        Mesaj Gönder
                    </h2>

                    <form onSubmit={handleSubmit} noValidate>
                        <div className="mb-6">
                            <label className="block text-base text-gray-800 mb-2 font-medium">
                                Ad <span className="text-red-500">*</span>
                            </label>
                            <input
                                type="text"
                                name="name"
                                value={formData.name}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                className={`w-full px-3 py-3 text-base border rounded focus:outline-none focus:ring-2 focus:ring-[#1e5a96] focus:border-transparent transition-colors ${errors.name && touched.name
                                    ? 'border-red-500 bg-red-50'
                                    : 'border-gray-300'
                                    }`}
                                aria-invalid={errors.name && touched.name ? 'true' : 'false'}
                                aria-describedby={errors.name && touched.name ? 'name-error' : undefined}
                            />
                            {errors.name && touched.name && (
                                <p id="name-error" className="mt-1 text-sm text-red-500">
                                    {errors.name}
                                </p>
                            )}
                        </div>

                        <div className="mb-6">
                            <label className="block text-base text-gray-800 mb-2 font-medium">
                                E-posta <span className="text-red-500">*</span>
                            </label>
                            <input
                                type="email"
                                name="email"
                                value={formData.email}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                className={`w-full px-3 py-3 text-base border rounded focus:outline-none focus:ring-2 focus:ring-[#1e5a96] focus:border-transparent transition-colors ${errors.email && touched.email
                                    ? 'border-red-500 bg-red-50'
                                    : 'border-gray-300'
                                    }`}
                                aria-invalid={errors.email && touched.email ? 'true' : 'false'}
                                aria-describedby={errors.email && touched.email ? 'email-error' : undefined}
                            />
                            {errors.email && touched.email && (
                                <p id="email-error" className="mt-1 text-sm text-red-500">
                                    {errors.email}
                                </p>
                            )}
                        </div>

                        <div className="mb-6">
                            <label className="block text-base text-gray-800 mb-2 font-medium">
                                Konu <span className="text-red-500">*</span>
                            </label>
                            <input
                                type="text"
                                name="title"
                                value={formData.title}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                className={`w-full px-3 py-3 text-base border rounded focus:outline-none focus:ring-2 focus:ring-[#1e5a96] focus:border-transparent transition-colors ${errors.title && touched.title
                                    ? 'border-red-500 bg-red-50'
                                    : 'border-gray-300'
                                    }`}
                                aria-invalid={errors.title && touched.title ? 'true' : 'false'}
                                aria-describedby={errors.title && touched.title ? 'title-error' : undefined}
                            />
                            {errors.title && touched.title && (
                                <p id="title-error" className="mt-1 text-sm text-red-500">
                                    {errors.title}
                                </p>
                            )}
                        </div>

                        <div className="mb-6">
                            <label className="block text-base text-gray-800 mb-2 font-medium">
                                Mesaj <span className="text-red-500">*</span>
                                <span className="text-gray-500 text-sm ml-2">
                                    ({formData.message.length}/1000)
                                </span>
                            </label>
                            <textarea
                                name="message"
                                value={formData.message}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                className={`w-full px-3 py-3 text-base border rounded focus:outline-none focus:ring-2 focus:ring-[#1e5a96] focus:border-transparent resize-y transition-colors ${errors.message && touched.message
                                    ? 'border-red-500 bg-red-50'
                                    : 'border-gray-300'
                                    }`}
                                rows="5"
                                aria-invalid={errors.message && touched.message ? 'true' : 'false'}
                                aria-describedby={errors.message && touched.message ? 'message-error' : undefined}
                            />
                            {errors.message && touched.message && (
                                <p id="message-error" className="mt-1 text-sm text-red-500">
                                    {errors.message}
                                </p>
                            )}
                        </div>

                        <button
                            type="submit"
                            className="w-full bg-[#1e5a96] text-white px-8 py-4 text-base rounded font-semibold transition-all hover:bg-[#164773] disabled:opacity-50 disabled:cursor-not-allowed hover:shadow-lg"
                            disabled={loading}
                        >
                            {loading ? "Gönderiliyor..." : "Gönder"}
                        </button>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default Contact;